import { actions } from "@grandvisionhq/state";
const loadReviewWrite = actions.action(
  "LOAD_REVIEW_WRITE",
  actions.payload()
);
const loadReviewSnippet = actions.action(
  "LOAD_REVIEW_SNIPPET",
  actions.payload()
);
const loadReviewDisplay = actions.action(
  "LOAD_REVIEW_DISPLAY",
  actions.payload()
);
const updateReviewDisplay = actions.action(
  "UPDATE_REVIEW_DISPLAY",
  actions.payload()
);
export {
  loadReviewDisplay,
  loadReviewSnippet,
  loadReviewWrite,
  updateReviewDisplay
};
//# sourceMappingURL=actions.js.map
